(function () {
  'use strict';

  function initializeAllyComponent(container) {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const expandButton = container.querySelector(
      '.ally-intelligence-expand-button'
    );

    // Click handler for expand/collapse
    container.addEventListener('click', (e) => {
      if (
        e.target.closest('a') ||
        (e.target.closest('button') &&
          !e.target.closest('.ally-intelligence-expand-button'))
      ) {
        return;
      }

      const expanded = container.toggleAttribute('data-expanded');
      if (expandButton && expandButton.firstChild) {
        expandButton.firstChild.textContent = expanded
          ? 'Show Less '
          : 'Read More ';
      }
    });
  }

  function runInitializations() {
    document
      .querySelectorAll(
        '.ally-intelligence-container:not([data-initialized="true"])'
      )
      .forEach(initializeAllyComponent);
  }

  document.addEventListener('DOMContentLoaded', runInitializations);
  // Dinamik olarak yüklenen içerikler için özel bir event dinleyicisi
  document.addEventListener('bfwt:content-loaded', runInitializations);
})();
